// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AlertModal_center__rkNve {
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  justify-content: center;
}
.AlertModal_center__rkNve button {
  margin-left: 5px;
  margin-right: 5px;
}

.AlertModal_title__j3HFE {
  font-size: 1.8em;
  text-align: center;
  align-items: center;
  justify-content: center;
}

.AlertModal_grid__kdE60 {
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
@media (min-width: 320px) {
  .AlertModal_grid__kdE60 {
    flex-direction: column;
  }
}
@media (min-width: 480px) {
  .AlertModal_grid__kdE60 {
    flex-direction: column;
  }
}
@media (min-width: 720px) {
  .AlertModal_grid__kdE60 {
    flex-direction: row;
  }
}

.AlertModal_modal__r\\+mrB {
  animation: AlertModal_slide__GF0LK 0.8s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}

@keyframes AlertModal_slide__GF0LK {
  0% {
    transform: translateY(200%);
  }
  100% {
    transform: translateY(0%);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/AlertModal/AlertModal.module.scss","webpack://./src/_common/scss/_media.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;AADF;AAGE;EACE,gBAAA;EACA,iBAAA;AADJ;;AAKA;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;AAFF;;AAKA;EACE,mBAAA;EACA,mBAAA;EACA,uBAAA;AAFF;ACZI;EDWJ;IAMI,sBAAA;EADF;AACF;ACbI;EDOJ;IAUI,sBAAA;EAAF;AACF;ACdI;EDGJ;IAcI,mBAAA;EACF;AACF;;AAEA;EACE,mFAAA;AACF;;AAEA;EACE;IACE,2BAAA;EACF;EAEA;IACE,yBAAA;EAAF;AACF","sourcesContent":["@import '@common/scss/_media';\n\n.center {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  align-items: center;\n  justify-content: center;\n\n  button {\n    margin-left: 5px;\n    margin-right: 5px;\n  }\n}\n\n.title {\n  font-size: 1.8em;\n  text-align: center;\n  align-items: center;\n  justify-content: center;\n}\n\n.grid {\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n\n  @include media(xss) {\n    flex-direction: column;\n  }\n\n  @include media(xs) {\n    flex-direction: column;\n  }\n\n  @include media(sm) {\n    flex-direction: row;\n  }\n}\n\n.modal {\n  animation: slide 0.8s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;\n}\n\n@keyframes slide {\n  0% {\n    transform: translateY(200%);\n  }\n\n  100% {\n    transform: translateY(0%);\n  }\n}\n","// variables:\n$breakpoint-xss: 320px;\n$breakpoint-xs: 480px;\n$breakpoint-sm: 720px;\n$breakpoint-md: 1023px;\n$breakpoint-lg: 1360px;\n$breakpoint-xl: 1600px;\n\n@mixin media($media) {\n  // MOBILE FIRST\n  @if $media == xss {\n    @media (min-width: $breakpoint-xss) {\n      @content;\n    }\n  } @else if $media == xs {\n    @media (min-width: $breakpoint-xs) {\n      @content;\n    }\n  } @else if $media == sm {\n    @media (min-width: $breakpoint-sm) {\n      @content;\n    }\n  } @else if $media == md {\n    @media (min-width: $breakpoint-md) {\n      @content;\n    }\n  } @else if $media == lg {\n    @media (min-width: $breakpoint-lg) {\n      @content;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"center": `AlertModal_center__rkNve`,
	"title": `AlertModal_title__j3HFE`,
	"grid": `AlertModal_grid__kdE60`,
	"modal": `AlertModal_modal__r+mrB`,
	"slide": `AlertModal_slide__GF0LK`
};
export default ___CSS_LOADER_EXPORT___;
